{
  "Para1": "Selecione um layout de painel entre as opções abaixo:",
  "DashboardDisplaySettings_SectionHeader": "Configurações do visor",
  "NAME": "DashboardDisplaySettings"
}